export default function NavArrowRightIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.977 9.999L6.852 5.874 8.03 4.695 13.333 10 8.03 15.302l-1.178-1.178 4.125-4.125z"
        fill={props.fill}
      />
    </svg>
  )
}